var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TopNav',{attrs:{"titleImage":_vm.titleImage,"showTutorial":function () {
        this$1.SET_SHOW_INTRO_SLIDER(true);
      }}}),_c('v-main',[_c('v-card',{staticClass:"overflow-hidden",staticStyle:{"height":"100%","border-radious":"0px"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }